import * as ko from "knockout";
import entityBase from "entityBase";

export class product_custom_warranty_coverage extends entityBase {
  label: KnockoutObservable<string>;
  deadline_dt: KnockoutObservable<string>;
  deadline_dttm: KnockoutObservable<Date>;
  order: KnockoutObservable<number>;

  constructor(item?: any) {
    super();
    this.label = ko.observable(item?.portal_message_id);
    this.deadline_dt = ko.observable(item?.deadline);
    this.deadline_dttm = ko.observable(this.formatJSONDate(item?.deadline));
    this.order = ko.observable(item?.rule_order);
  }
}
